export const base = {
  logo: '/img/logo.png',
  logoWhite: '/img/logo-blanco.png',
  logoS: '/img/3.png',
  email: 'innovacion@creson.edu.mx',
  programa: '/img/programa-FINTEC.png',
  goal: 'Identificar las tendencias en innovación que están transformando el mundo para adaptarlas a la práctica educativa y conocer nuevos recursos didácticos que permitan enriquecer el proceso enseñanza – aprendizaje',
  mainSpeakers: [
    {
      name: 'Dale Johnson',
      profile: `<p>Dale P. Johnson es Director de Innovación Digital para el Instituto Universitario del Diseño de la Universidad Estatal de Arizona. Trabaja con líderes
       de distintas universidades para desarrollar e implementar soluciones digitales que permitan el éxito de los estudiantes. Dichos esfuerzos, le hicieron merecedor del 
       premio Sally M. Johnstone, en el año 2016. Este reconocimiento le ha sido otorgado gracias a su liderazgo intelectual, su excelencia en la práctica y sus demostradas 
       capacidades como líder. En 2018, fue honrado por el IMS Global Learning Consortium con un reconocimiento a la excelencia en el servicio por su liderazgo en la comunidad 
       de práctica de software pedagógico adaptativo.
      </p>`,
      picture: '/img/event/dale.png',
      styleClass: 'col-lg-6 col-md-6',
    },
    {
      name: 'Patricia Langford',
      profile: `<p>Dra. en Ciencias Sociales y Humanidades, Maestra en Investigación Educativa y Licenciada en la Enseñanza del Inglés por la Universidad Autónoma de 
      Aguascalientes. Cuenta con la Especialidad en Política y Gestión Educativa por la Facultad Latinoamericana de Ciencias Sociales, FLACSO. Cuenta con un Postdoctorado 
      en enseñanza de Ciencias y Desarrollo de Habilidades Socioemocionales mediados por la implementación de plataformas de simulación. La Dra. Langford ha sido 
      evaluadora de programas de desarrollo social y consultora de proyectos de regionalización en diversas entidades federativas.</p> `,
      picture: '/img/event/patricia.jpg',
      styleClass: 'col-lg-6 col-md-6',
    },
  ],
  speakers: [
    {
      name: 'Roberto Saint Martin',
      from: 'Director General de RobotiX',
      picture: 'img/event/roberto.png',
    },

    {
      name: 'Leonardo Glasserman',
      from: 'Director de la maestría en emprendimiento educativo, Profesor-investigador de la escuela de humanidades y educación, Tecnológico de monterrey',
      picture: 'img/event/leonardo.jpg',
    },
    {
      name: 'Sagrario Rodríguez',
      from: 'Entrenadora certificada Google for Education',
      picture: 'img/event/sagrario.jpg',
    },
    {
      name: 'Alfredo González Estrada',
      from: 'Desarrollador de contenidos, Grupo empresarial emprove Moodle partner en méxico',
      picture: 'img/event/alfredo.jpg',
    },
    {
      name: 'Israel Vázquez',
      from: 'Consultor pedagógico para Edilar y entrenador certificado de Google',
      picture: 'img/event/israel.jpg',
    },

    {
      name: 'Samuel de Jesús',
      from: 'Director regional para Latam Intelliboard',
      picture: 'img/event/samuel-de-jesus.jpg',
    },
    {
      name: 'Adriana Carrillo Rosas',
      from: 'Profesora-investigadora del Centro Regional de Formación Profesional Docente',
      picture: 'img/event/adriana.png',
    },
  ],
};
